'use client'
import * as React from "react"

import { cn } from "@repo/web-ui/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"


function ClickableCard({ className, ...props }: React.ComponentProps<"button">) {
  return (
    <button
      data-slot="card"
      className={cn(
        "bg-card text-card-foreground text-start flex flex-col gap-6 rounded-xl border py-6 shadow-sm hover:bg-primary/10 data-[active=true]:bg-primary/20",
        className
      )}
      {...props}
    />
  )
}

function ClickableCardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn("flex flex-col gap-1.5 px-6", className)}
      {...props}
    />
  )
}

function ClickableCardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-title"
      className={cn("leading-none font-semibold", className)}
      {...props}
    />
  )
}

function ClickableCardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn("text-muted-foreground text-sm", className)}
      {...props}
    />
  )
}

function ClickableCardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("px-6", className)}
      {...props}
    />
  )
}

function ClickableCardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn("flex items-center px-6", className)}
      {...props}
    />
  )
}

export { ClickableCard, ClickableCardHeader, ClickableCardFooter, ClickableCardTitle, ClickableCardDescription, ClickableCardContent }
